import React, { useState } from 'react'
import { Icon, Popup } from 'semantic-ui-react'
import { formatNumber, handleErrors } from '~/utils/helpers'
import { WidgetCard, WidgetTitle } from '../../style'
import { AbrechnungRow, AbrechnungMonth, AbrechnungAmount } from './style'
import { useMilkMoney } from '../../MilkMoneyContext'
import { InvoicesWidgetSkeleton } from '../../Skeletons'
import { DownloadService } from '~/api/services/downloadFiles'
import dayjs from 'dayjs'
import CustomIcon from '~/components/CustomIcon'
import { useTranslation } from 'react-i18next'

const InvoicesWidget: React.FC = () => {
  const { t } = useTranslation()
  const { milkMoneyData, isLoading } = useMilkMoney()
  
  const [loadingId, setLoadingId] = useState<number | null>(null)

  if (isLoading) return <InvoicesWidgetSkeleton />

  const milkPayments = milkMoneyData?.milkPayments ?? []

  if (!milkPayments.length) {
    return (
      <WidgetCard>
        <WidgetTitle>{t('Billings')}</WidgetTitle>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px', color: '#999', fontSize: '14px' }}>
          {t('No data available')}
        </div>
      </WidgetCard>
    )
  }

  const handleDownload = async (id: number) => {
    setLoadingId(id)
    try {
      await DownloadService.downloadFile(`milk-money/milk-payment/temp/invoices/${id}/preview/pdf`)
    } catch (error) {
      handleErrors(error)
    } finally {
      setLoadingId(null)
    }
  }

  return (
    <WidgetCard>
      <WidgetTitle>{t('Billings')}</WidgetTitle>
      {milkPayments.map((item) => (
        <AbrechnungRow key={item.id}>
          <AbrechnungMonth>{dayjs(item.billingMonth).format('MMMM YYYY')}</AbrechnungMonth>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AbrechnungAmount>
              {`${formatNumber(parseFloat(item.total), 2)} CHF`}
            </AbrechnungAmount>
            {loadingId === item.id ? (
              <Icon name='spinner' loading style={{ fontSize: '1.2em' }} />
            ) : (
              <Popup
                content={t('Download MGA')}
                trigger={
                  <span style={{ cursor: 'pointer' }} onClick={() => handleDownload(item.id)}>
                    <CustomIcon name={'file pdf'} style={{ fontSize: '1.2em' }}/>
                  </span>
                }
              />
            )}
          </div>
        </AbrechnungRow>
      ))}
    </WidgetCard>
  )
}

export default InvoicesWidget
